import { InformationDocumentation } from "../../components/informationDocument/informationDocument";

/**
 * @function Information displays the information page
 * @returns {JSX.Element} HTML content
 */
const Information: React.FC = () => {

  return (
    <>
      <InformationDocumentation />
    </>
  )
}

export { Information };